var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    width: 332,
    height: 166,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 332 166",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    x: -74,
    y: -65,
    width: 480,
    height: 296,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -74,
    y: -65,
    width: 480,
    height: 296,
    rx: 8,
    ry: 8,
    fill: "#f6f9fc"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 144.51,
    y: 27.04,
    width: 42.22,
    height: 17.91,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 144.51,
    y: 122.05,
    width: 43.2,
    height: 17.91,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 16,
    width: 300,
    height: 39,
    rx: 5.37,
    ry: 5.37
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152.49,29.35c.5-.62.83-1.46.75-2.31-.73.04-1.62.48-2.13,1.1-.46.53-.87,1.4-.76,2.22.82.07,1.63-.41,2.15-1.01Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.22,30.53c-1.19-.07-2.2.67-2.76.67s-1.43-.64-2.37-.62c-1.22.02-2.35.71-2.97,1.81-1.27,2.2-.34,5.46.9,7.25.6.89,1.33,1.86,2.28,1.83.9-.04,1.26-.58,2.35-.58s1.42.58,2.37.57c.99-.02,1.61-.89,2.21-1.77.69-1.01.97-1.98.99-2.04-.02-.02-1.91-.74-1.93-2.92-.02-1.82,1.49-2.69,1.56-2.75-.85-1.26-2.18-1.4-2.64-1.43Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.55,28.06c2.58,0,4.37,1.78,4.37,4.36s-1.83,4.38-4.44,4.38h-2.85v4.54h-2.06v-13.29h4.98ZM160.63,35.07h2.37c1.8,0,2.82-.97,2.82-2.64s-1.02-2.63-2.81-2.63h-2.38v5.28Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.46,38.59c0-1.69,1.3-2.74,3.6-2.86l2.65-.16v-.75c0-1.08-.73-1.72-1.94-1.72-1.15,0-1.87.55-2.04,1.42h-1.88c.11-1.75,1.6-3.04,4-3.04s3.85,1.24,3.85,3.19v6.68h-1.91v-1.59h-.05c-.56,1.08-1.79,1.76-3.06,1.76-1.9,0-3.22-1.18-3.22-2.92ZM174.72,37.72v-.76l-2.38.15c-1.19.08-1.86.61-1.86,1.44s.7,1.4,1.77,1.4c1.39,0,2.48-.96,2.48-2.22Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.5,44.91v-1.61c.15.04.48.04.65.04.92,0,1.42-.39,1.72-1.38,0-.02.17-.59.17-.6l-3.5-9.7h2.15l2.45,7.88h.04l2.45-7.88h2.1l-3.63,10.19c-.83,2.35-1.79,3.1-3.79,3.1-.17,0-.66-.02-.81-.05Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 331,
    height: 70,
    rx: 7.5,
    ry: 7.5,
    fill: "none",
    stroke: "#abb5c5",
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 95.5,
    width: 331,
    height: 70,
    rx: 7.5,
    ry: 7.5,
    fill: "none",
    stroke: "#abb5c5",
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 111,
    width: 300,
    height: 39,
    rx: 5.37,
    ry: 5.37
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M165.08,124.82v4.3h2.65c.63,0,1.15-.21,1.57-.64.42-.42.64-.93.64-1.51s-.21-1.07-.64-1.5c-.41-.44-.94-.65-1.57-.65h-2.65ZM165.08,130.64v4.99h-1.58v-12.32h4.2c1.07,0,1.97.35,2.72,1.07.76.71,1.14,1.58,1.14,2.6s-.38,1.92-1.14,2.62c-.74.7-1.64,1.05-2.72,1.05h-2.62ZM173.16,133.05c0,.41.17.76.53,1.03.35.27.76.41,1.23.41.67,0,1.26-.25,1.78-.74.52-.49.78-1.07.78-1.74-.5-.39-1.18-.58-2.07-.58-.64,0-1.18.16-1.61.46-.43.31-.65.69-.65,1.15ZM175.21,126.92c1.17,0,2.1.31,2.77.94.68.63,1.02,1.48,1.02,2.57v5.2h-1.52v-1.17h-.07c-.65.96-1.53,1.44-2.62,1.44-.93,0-1.71-.28-2.33-.83-.62-.55-.94-1.24-.94-2.07,0-.87.33-1.57.99-2.08.66-.52,1.54-.77,2.64-.77.94,0,1.72.17,2.32.52v-.36c0-.55-.22-1.02-.65-1.4-.42-.38-.97-.58-1.53-.58-.88,0-1.58.37-2.1,1.12l-1.4-.88c.77-1.1,1.91-1.65,3.41-1.65ZM187.7,127.2l-5.29,12.15h-1.64l1.96-4.25-3.48-7.9h1.72l2.52,6.06h.03l2.45-6.06h1.72Z",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.68,129.56c0-.5-.04-.98-.12-1.44h-6.68v2.73h3.83c-.08.44-.24.85-.49,1.22-.24.37-.56.69-.93.93v1.77h2.29c1.34-1.23,2.11-3.06,2.11-5.21Z",
    fill: "#4285f4",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.87,136.48c1.91,0,3.52-.63,4.7-1.71l-2.29-1.77c-.63.43-1.45.68-2.41.68-1.85,0-3.42-1.24-3.98-2.92h-2.35v1.82c.59,1.17,1.5,2.16,2.61,2.85,1.12.69,2.4,1.05,3.72,1.05",
    fill: "#34a853",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.89,130.75c-.3-.88-.3-1.83,0-2.71v-1.82h-2.35c-.5.99-.76,2.07-.76,3.18s.27,2.22.76,3.18l2.35-1.82h0Z",
    fill: "#fabb05",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.87,125.12c1.04,0,1.98.36,2.72,1.06h0s2.02-2.02,2.02-2.02c-1.23-1.14-2.83-1.84-4.74-1.84-1.31,0-2.6.36-3.72,1.05-1.12.69-2.02,1.67-2.61,2.85l2.35,1.82c.56-1.68,2.13-2.92,3.98-2.92",
    fill: "#e94235",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPay);
export default __webpack_public_path__ + "static/media/pay.85a9703f69267ebcdd8f6c6b8154124f.svg";
export { ForwardRef as ReactComponent };